import { DOUBLE_DASH } from 'consts/placeholders';
import { DetailedInventoryAsset } from 'components/common/types/DetailedInventoryAsset.types';
import Timeline, { TimelineItem } from 'lib/Timeline';

import PriceInfo from './PriceInfo';
import { Button as ReadMoreButton } from '../ReadMoreSections';

type PricesProps = {
  assetPrices?: DetailedInventoryAsset['prices'];
  toggleReadMore?: () => void;
  maxRecordsToShow: number;
};

const Prices = ({
  assetPrices = [],
  toggleReadMore = (): null => null,
  maxRecordsToShow,
}: PricesProps): React.ReactElement => {
  return (
    <div>
      <h2 className="mb-8 sub-header-base">Prices</h2>
      <div className="pl-2" data-test-id="asset-prices">
        <Timeline>
          {assetPrices.length ? (
            assetPrices
              .slice(0, maxRecordsToShow)
              .map((price) => <PriceInfo key={`${price.startDate}${price.startOffset}`} price={price} />)
          ) : (
            <TimelineItem title={<p className="body-base">{DOUBLE_DASH}</p>} />
          )}
        </Timeline>
        {assetPrices.length > 3 ? <ReadMoreButton onClick={toggleReadMore} /> : null}
      </div>
    </div>
  );
};

export default Prices;
